import InfoBanner from './InfoBanner'

export default InfoBanner
